"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    COMPLETED: 'completed',
    PENDING: 'pending',
    CANCELLED: 'cancelled',
};
//# sourceMappingURL=invitationStatus.js.map